export const url_api = {
	Prod: 'https://api2.farmebox.com.br/prod/api',
	Lab: 'https://api2.farmebox.com.br/lab/api',
	Dev: 'https://api2.farmebox.com.br/dev/api',
	Staging: 'https://api2.farmebox.com.br/staging/api',
	Local: 'http://localhost:3333/api'
};
